import { render } from "./MySideBar.vue?vue&type=template&id=08f2ad6f"
import script from "./MySideBar.vue?vue&type=script&lang=js"
export * from "./MySideBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__